import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_work_related_injuries_that_resulted_least_three'

export const dataPointDefinition = {
  retracedId: 'number_work_related_injuries_that_resulted_least_three',
  name: 'Number of work-related injuries that resulted in at least three days of absence from work:',
  description: 'Provide the number of work-related injuries that resulted in at least three days of absence from work.',
  meta: {
    slcpMeta: {
      key: 'hs-fir-17',
      number: 'HS-FIR-12',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-fir-17', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30980,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
